<template>
  <div class="app">
    <vue-progress-bar></vue-progress-bar>
    <div class="bg-christmas" @click="isShowTheme = false" v-if="isShowTheme && christmasTheme"></div>
    <div class="container-swich-christmas" v-if="christmasTheme">
      <div class="input-group">
      <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true"
                v-model="changeTheme"/>
      <p style="margin-left: 10px; margin-bottom: 0;">{{$t('common.christmas_theme')}}</p>
      </div>
    </div>
    <div class=" tool-tip-christmas container-swich-christmas" v-if="isShowTheme && christmasTheme">
        <span class="switch-device--desktop">
          <p class="text-tooltips">{{$t('common.notifi_christmas')}}</p>
          <button type="button" class="btn btn-primary btn-tooltips" @click="isShowTheme=!isShowTheme">Skip</button>
        </span>
    </div>
    <header class="app-header navbar">

      <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
        <span class="navbar-toggler-icon"></span>
      </button>
      <a class="navbar-brand" href="/" :style="'background-image: url(' + logo + ')'">
      </a>
      <button class="navbar-toggler sidebar-minimizer d-md-down-none h-100 b-r-1" type="button" @click="sidebarToggle">
        <span class="navbar-toggler-icon"></span>
      </button>
      <b-navbar-nav class="ml-auto">

        <div class="main-language" id="switchClient">
          <switch-client></switch-client>
        </div>
        <div class="main-language">
          <change-language></change-language>
        </div>
        <HeaderDropdownAccnt/>
      </b-navbar-nav>
    </header>
    <div class="app-body">
      <Sidebar :navItems="nav" :sysFlag="sysFlag" :userFlag="userFlag"/>
      <main class="main">
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <aside class="aside-menu">
        <b-tabs v-model="selected">
          <b-tab>
            <template slot="title">
              <i class='fa fa-cutlery'></i>
            </template>
            <Callout v-if="menus == null || menus.length <= 0" class="m-0 py-3">
              <div class="version-label full-width text-center"><strong>{{$t('message.no_data')}}</strong></div>
              <hr class="mt-3 mb-0">
            </Callout>
            <Callout v-for="(item, index) in menus" :key="item.id" :variant="getTypeByStatus(item.status)" class="m-0 py-3">
              <div class="float-right">
                <b-button size="sm" variant="primary" v-if="item.status == 4" v-b-tooltip.hover :title="$t('gms_revert')">
                  <i class="fa fa-level-down"></i>
                </b-button>
                <b-button size="sm" variant="success" v-if="item.status == 2" v-b-tooltip.hover :title="$t('gms_published')">
                  <i class="fa fa-level-up"></i>
                </b-button>
                <b-button size="sm" variant="danger" v-if="item.status != 3" v-b-tooltip.hover :title="$t('delete')">
                  <i class="fa fa-trash-o"></i>
                </b-button>
              </div>
              <div class="version-label">
                <strong>
                  <i class="fa fa-share-square" v-if="item.status == 1"></i>
                  <i class="fa fa-edit" v-if="item.status == 2"></i>
                  <i class="fa fa-circle-o-notch fa-spin" v-if="item.status == 3"></i>
                  <i class="fa fa-laptop" v-if="item.status == 4"></i>
                  {{item.version}}
                </strong>
              </div>
              <small class="text-muted mr-3"><i class="fa fa-user"></i>&nbsp; {{item.user}}</small>
              <small class="text-muted"><i class="icon-calendar"></i>&nbsp; {{item.time}}</small>
              <hr class="mt-3 mb-0">
            </Callout>
          </b-tab>
          <b-tab>
            <template slot="title">
              <i class='fa fa-inbox'></i>
            </template>
            <Callout v-if="combos == null || combos.length <= 0" class="m-0 py-3">
              <div class="version-label full-width text-center"><strong>{{$t('message.no_data')}}</strong></div>
              <hr class="mt-3 mb-0">
            </Callout>
            <Callout v-for="(item, index) in combos" :key="item.id" :variant="getTypeByStatus(item.status)" class="m-0 py-3">
              <div class="float-right">
                <b-button size="sm" variant="primary" v-if="item.status == 4" v-b-tooltip.hover :title="$t('gms_revert')">
                  <i class="fa fa-level-down"></i>
                </b-button>
                <b-button size="sm" variant="success" v-if="item.status == 2" v-b-tooltip.hover :title="$t('gms_published')">
                  <i class="fa fa-level-up"></i>
                </b-button>
                <b-button size="sm" variant="danger" v-if="item.status != 3" v-b-tooltip.hover :title="$t('delete')">
                  <i class="fa fa-trash-o"></i>
                </b-button>
              </div>
              <div class="version-label">
                <strong>
                  <i class="fa fa-share-square" v-if="item.status == 1"></i>
                  <i class="fa fa-edit" v-if="item.status == 2"></i>
                  <i class="fa fa-circle-o-notch fa-spin" v-if="item.status == 3"></i>
                  <i class="fa fa-laptop" v-if="item.status == 4"></i>
                  {{item.version}}
                </strong>
              </div>
              <small class="text-muted mr-3"><i class="fa fa-user"></i>&nbsp; {{item.user}}</small>
              <small class="text-muted"><i class="icon-calendar"></i>&nbsp; {{item.time}}</small>
              <hr class="mt-3 mb-0">
            </Callout>
          </b-tab>
          <b-tab>
            <template slot="title">
              <i class='fa fa-dot-circle-o'></i>
            </template>
            <Callout v-if="outlets == null || outlets.length <= 0" class="m-0 py-3">
              <div class="version-label full-width text-center"><strong>{{$t('message.no_data')}}</strong></div>
              <hr class="mt-3 mb-0">
            </Callout>
            <Callout v-for="(item, index) in outlets" :key="item.id" :variant="getTypeByStatus(item.status)" class="m-0 py-3">
              <div class="float-right">
                <b-button size="sm" variant="primary" v-if="item.status == 4" v-b-tooltip.hover :title="$t('gms_revert')">
                  <i class="fa fa-level-down"></i>
                </b-button>
                <b-button size="sm" variant="success" v-if="item.status == 2" v-b-tooltip.hover :title="$t('gms_published')">
                  <i class="fa fa-level-up"></i>
                </b-button>
                <b-button size="sm" variant="danger" v-if="item.status != 3" v-b-tooltip.hover :title="$t('delete')">
                  <i class="fa fa-trash-o"></i>
                </b-button>
              </div>
              <div class="version-label">
                <strong>
                  <i class="fa fa-share-square" v-if="item.status == 1"></i>
                  <i class="fa fa-edit" v-if="item.status == 2"></i>
                  <i class="fa fa-circle-o-notch fa-spin" v-if="item.status == 3"></i>
                  <i class="fa fa-laptop" v-if="item.status == 4"></i>
                  {{item.version}}
                </strong>
              </div>
              <small class="text-muted mr-3"><i class="fa fa-user"></i>&nbsp; {{item.user}}</small>
              <small class="text-muted"><i class="icon-calendar"></i>&nbsp; {{item.time}}</small>
              <hr class="mt-3 mb-0">
            </Callout>
          </b-tab>
        </b-tabs>
      </aside>
    </div>
    <AppFooter/>
  </div>
</template>

<style scoped>
  .main-language {
    margin-top: 15px;
  }
  .app-header.navbar .navbar-brand {
    /*background-image: url("/static/img/logo_wide%40x2.png");*/
    background-image: none;
    background-size: 80% auto;
    height: 50px;
    margin-top: -5px;
    padding: 0.2rem 0.4rem;
  }
  .version-label {
    min-height: 26px;
  }

  #switchClient {
    padding-right: 3px;
  }

  .container-swich-christmas {
    position: fixed;
    z-index: 1041;
    right: 350px;
    top: 16px;
    background-color: white;
    padding: 5px 10px;
    border-radius: 20px;
  }

  .container-swich-christmas .switch.switch-icon {
    margin-bottom: 0;
  }

  .tool-tip-christmas {
    color: #000 !important;
    margin-bottom: 10px !important;
    padding: 10px !important;
    border-color: #fff;
    margin: 10px 20px 0px;
    border-radius: 5px;
    top:80px;
    width: 380px;
    height: 170px;
  }

  .tool-tip-christmas::before {
    position: absolute;
    content: "";
    width: 100px;
    height: 130px;
    top: -39%;
    left: 85%;
    margin-top: 0;
    background-image: url('../assets/images/hat_christmas.png');
  }

  .bg-christmas {
    position: fixed;
    background-color: #000;
    opacity: 0.5;
    width: 100%;
    height: 100vh;
    z-index: 1040;
  }
  .text-tooltips{
    padding: 20px 0px 0px 0px;
  }
  .btn-tooltips{
    left: 42%;
    margin: 0 auto;
    position: absolute;
  }
</style>

<script>
import { Header as AppHeader, Sidebar, Aside as AppAside, Footer as AppFooter } from '../components/'
import HeaderDropdownAccnt from '../components/Header/HeaderDropdownAccnt.vue'
import ChangeLanguage from '../components/Partials/ChangeLanguages.vue'
import SwitchClient from '../components/Partials/SwitchClient.vue'
import Callout from '../components/Callout'
import cSwitch from '../components/Switch'

export default {
  name: 'HomeLayout',
  components: {
    AppHeader,
    Sidebar,
    AppAside,
    AppFooter,
    Callout,
    HeaderDropdownAccnt,
    ChangeLanguage,
    SwitchClient,
    cSwitch
  },
  data () {
    return {
      logo: 'https://gms.phdvasia.com/static/img/logo_wide%40x2.png',
      selected: 0,
      menus: [],
      combos: [],
      outlets: [],
      userFlag: false,
      sysFlag: false,
      nav: [
        {
          name: 'home',
          url: '/home',
          icon: 'fa fa-home',
          disable: false
        },
        {
          title: true,
          name: 'system_management',
          class: '',
          wrapper: {
            element: 'span',
            attributes: {}
          },
          disable: false
        },
        {
          name: 'menu',
          url: '/menu',
          icon: 'fa fa-cutlery',
          disable: false
        },
        {
          name: 'menu_half_half',
          url: '/menu-half-half',
          icon: 'fa fa-cutlery',
          disable: false
        },
        {
          name: 'menu_attribute',
          url: '/menu-attribute',
          icon: 'fa fa-cutlery',
          disable: false
        },
        {
          name: 'combo',
          url: '/combo',
          icon: 'fa fa-inbox',
          disable: false
        },
        {
          name: 'menu_group',
          url: '/menu-group',
          icon: 'fa fa-object-group',
          disable: false
        },
        {
          name: 'sequence',
          url: '/sequence',
          icon: 'fa fa-list-ol',
          disable: false
        },
        {
          name: 'first_layer',
          url: '/first-layer',
          icon: 'fa fa-object-group',
          disable: false
        },
        {
          name: 'second_layer',
          url: '/second-layer',
          icon: 'fa fa-object-group',
          disable: false
        },
        {
          name: 'topping',
          url: '/topping',
          icon: 'fa fa-object-group',
          disable: false
        },
        {
          name: 'coupons',
          url: '/coupon',
          icon: 'fa fa-gift',
          disable: false
        },
        {
          name: 'child_coupon',
          url: '/child-coupon',
          icon: 'fa fa-gift',
          disable: false
        },
        {
          name: 'ges_coupon',
          url: '/ges-coupon',
          icon: 'fa fa-gift',
          disable: false
        },
        {
          name: 'customer_coupon',
          url: '/customer-coupon',
          icon: 'fa fa-gift',
          disable: false
        },
        {
          name: 'outlets',
          url: '/outlets',
          icon: 'fa fa-dot-circle-o',
          disable: false
        },
        {
          name: 'store_group',
          alias: 'outlet-groups',
          url: '/store-group',
          icon: 'fa fa-group',
          disable: false
        },
        {
          name: 'orders',
          url: '/order',
          icon: 'fa fa-list',
          disable: false,
          children:[{
            disable: false,
            class: '',
            name:'all_orders',
            url: '/orders',
            icon: 'fa fa-shopping-basket',
            badge:{},
            variant:''
          }, {
            disable: false,
            class: '',
            name: 'order_errors',
            url: '/order_errors',
            icon: 'fa fa-line-chart',
            badge: {},
            variant: ''
          }]
        },
        {
          name: 'customers',
          url: '/customers',
          icon: 'fa fa-user',
          disable: false
        },
        {
          name: 'category',
          url: '/category',
          icon: 'fa fa-list-alt',
          disable: false
        },
        {
          name: 'banner',
          url: '/banner',
          icon: 'fa fa-calendar',
          disable: false
        },
        {
          name: 'topic',
          url: '/topic',
          icon: 'fa fa-bullhorn',
          disable: false
        },
        {
          name: 'game',
          url: '/game',
          icon: 'fa fa-gamepad',
          disable: false,
          children:[{
            disable: false,
            class: '',
            name:'choose_game',
            url: '/game',
            icon: '',
            badge:{},
            variant:''
          }, {
            disable: false,
            class: '',
            name: 'game_rule',
            url: '/gaming_rule',
            icon: 'fa fa-gamepad',
            badge: {},
            variant: ''
          },{
            disable: false,
            class: '',
            name: 'grant_token_history',
            url: '/grant_token_history',
            icon: 'fa fa-history',
            badge: {},
            variant: ''
          }]
        },
        {
          name: 'content',
          url: '/content',
          icon: 'fa fa-file-code-o',
          disable: false
        },
        {
          name: 'main_report',
          url: '/report',
          icon: 'fa fa-list',
          disable: false,
          children:[{
            disable:false,
            class: '',
            name:'roster_report',
            url: '/roster-report',
            icon: 'fa fa-diamond',
            badge:{},
            variant:''
          },{
            disable:false,
            class: '',
            name:'hourly_sale_report',
            url: '/hourly-sale-report',
            icon: 'fa fa-calculator',
            badge:{},
            variant:''
          },{
            disable:false,
            class: '',
            name:'hit_rate_report',
            url: '/hit-rate-report',
            icon: 'fa fa-cube',
            badge: {},
            variant: ''
          }, {
            disable: false,
            class: '',
            name: 'sales_report',
            url: '/order-sales-report',
            icon: 'fa fa-line-chart',
            badge: {},
            variant: ''
          }, {
            disable: false,
            class: '',
            name: 'coupon_redemption_report',
            url: '/coupon-redemption-report',
            icon: 'fa fa-gift',
            badge: {},
            variant: ''
          }, {
            disable: false,
            class: '',
            name: 'hotpods',
            url: '/hotpods',
            icon: 'fa fa-map',
            badge: {},
            variant: ''
          }, {
            disable: false,
            class: '',
            name: 'store_health_check',
            url: '/store_health_check',
            icon: 'fa fa-map',
            badge: {},
            variant: ''
          }, {
            disable: false,
            class: '',
            name: 'contactless_curbside_transactions',
            url: '/contactless-curbside-transactions',
            icon: 'fa fa-line-chart',
            badge: {},
            variant: ''
          }
          ]
        },
        {
          name: 'blacklist_user',
          url: '/blacklist',
          icon: 'fa fa-ban',
          disable: false,
        },
        {
          name: 'earning_framework',
          url: '/earning-framework',
          icon: 'fa fa-money',
          disable: false
        },
        {
          name: 'email_template',
          url: '/email-template',
          icon: 'fa fa-list',
          disable: false,
          children: [
            {
              name: 'manage_email_templates',
              url: '/email-template',
              icon: 'fa fa-envelope',
              disable: false,
              badge: {},
              variant:''
            },
            {
              name: 'manage_email_triggers',
              url: '/email-template/email-trigger',
              icon: 'fa fa-bolt',
              disable: false,
              badge: {},
              variant:''
            }
          ]
        },
        {
          title: true,
          name: 'user_management',
          class: '',
          wrapper: {
            element: 'span',
            attributes: {}
          },
          disable: false
        },
        {
          name: 'clients',
          url: '/client',
          icon: 'fa fa-flag',
          disable: false
        },
        {
          name: 'users',
          url: '/users',
          icon: 'fa fa-user',
          disable: false
        },
        {
          name: 'audit_trail',
          url: '/audit-trails',
          icon: 'fa fa-list-alt',
          disable: false
        },
        {
          name: 'roles',
          url: '/roles',
          icon: 'fa fa-circle-o',
          disable: false
        },
        {
          name: 'error_message',
          url: '/error-message',
          icon: 'fa fa-circle-o',
          disable: false
        },
        {
          name: 'reason_status',
          url: '/reason-status',
          icon: 'fa fa-circle-o',
          disable: false
        }
      ],
      changeTheme: this.$session.get('theme') !== undefined ? this.$session.get('theme') : true,
      isShowTheme: this.$session.get('show_config_christmas') !== undefined ? this.$session.get('show_config_christmas') : true,
      christmasTheme: this.$store.getters.config.main.christmas_theme !== undefined ? this.$store.getters.config.main.christmas_theme : false
    }
  },
  destroyed() {
    this.$root.$off('activeTheme')
  },
  created() {
    this.$root.$on('activeTheme', () => {
      this.activeTheme()
    })
    let userInfo = this.$auth.user()
    let vm = this
    let adminIds = [1, 34, 35, 62]
    if (adminIds.indexOf(userInfo.user_id) < 0) {
      let modules = userInfo.modules
      let modules_tmp = modules
      if(typeof modules !== 'undefined') {
        for (var i = 0; i <= vm.nav.length; i++) {
          if (typeof vm.nav[i] !== 'undefined') {
            switch (vm.nav[i].name) {
              case 'external_coupon':
                this.checkMenuPermission(modules, 'get.v1.product-coupon-be.coupons', vm.nav[i], null)
                break
              case 'child_coupon':
                this.checkMenuPermission(modules, 'get.v1.product-coupon-be.coupons', vm.nav[i], null)
                break
              case 'coupons':
                this.checkMenuPermission(modules, 'get.v1.product-coupon-be.coupons', vm.nav[i], null)
                break
              case 'menu':
                this.checkMenuPermission(modules, 'get.v1.product-menu-be.menu', vm.nav[i], null)
                break
              case 'menu_half_half':
                this.checkMenuPermission(modules, 'get.v1.product-menu-be.menu', vm.nav[i], null)
                break
              case 'menu_attribute': // use the same permissions as menu
                this.checkMenuPermission(modules, 'get.v1.product-menu-be.attribute', vm.nav[i], null)
                break
              case 'menu_group':
                this.checkMenuPermission(modules, 'get.v1.product-menu-be.group', vm.nav[i], null)
                break
              case 'combo':
                this.checkMenuPermission(modules, 'get.v1.product-menu-be.combos', vm.nav[i], null)
                break
              case 'sequence':
                this.checkMenuPermission(modules, 'put.v1.product-menu-be.products-sequence', vm.nav[i], null)
                break
              case 'first_layer':
                this.checkMenuPermission(modules, 'get.v1.product-menu-be.first-layer', vm.nav[i], null)
                break
              case 'second_layer':
                this.checkMenuPermission(modules, 'get.v1.product-menu-be.second-layer', vm.nav[i], null)
                break
              case 'topping':
                this.checkMenuPermission(modules, 'get.v1.product-menu-be.topping-list', vm.nav[i], null)
                break
              case 'outlets':
                this.checkMenuPermission(modules, 'get.v1.product-hut-be.outlets', vm.nav[i], null)
                break
              case 'store_group':
                this.checkMenuPermission(modules, 'get.v1.product-hut-be.outlet-groups', vm.nav[i], null)
                break
              case 'orders':
                this.checkMenuPermission(modules, 'get.v1.product-order-be.orders', vm.nav[i], null)
                break
              case 'campaign':
                this.checkMenuPermission(modules, 'get.v1.product-campaign-be.campaign', vm.nav[i], null)
                break
              case 'topic':
                this.checkMenuPermission(modules, 'get.v1.product-campaign-be.topic.list', vm.nav[i], null)
                break
              case 'banner':
                this.checkMenuPermission(modules, 'get.v1.product-banner-be.banner.list', vm.nav[i], null)
                break
              case 'game':
                this.checkMenuPermission(modules, 'get.v1.product-coupon-be.games', vm.nav[i], null)
                break
              case 'content':
                this.checkMenuPermission(modules, 'get.v1.product-tenant.content', vm.nav[i], null)
                break
              case 'promotions':
                // todo
                break
              case 'customers':
                this.checkMenuPermission(modules, 'get.v1.product-customer.customers', vm.nav[i], null)
                break
              case 'clear_cache':
                // todo
                break
              case 'clients':
                this.checkMenuPermission(modules, 'get.v1.product-tenant.clients', vm.nav[i], modules_tmp)
                break
              case 'users':
                this.checkMenuPermission(modules, 'get.v1.product-tenant.users', vm.nav[i], null)
                break
              case 'roles':
                this.checkMenuPermission(modules, 'get.v1.product-tenant.roles', vm.nav[i], modules_tmp)
                break
              case 'error_message':
                this.checkMenuPermission(modules, 'get.v1.product-tenant.error_messages', vm.nav[i], null)
                break
              case 'category':
                this.checkMenuPermission(modules, 'get.v1.product-menu-be.display-categories', vm.nav[i], null)
                break
              case 'customer_coupon':
                this.checkMenuPermission(modules, 'get.v1.product-coupon-be.coupons', vm.nav[i], null)
                break
              case 'ges_coupon':
                this.checkMenuPermission(modules, 'get.v1.product-coupon-be.coupons', vm.nav[i], null)
                break
              case 'main_report':
                this.checkMenuPermission(modules, 'get.v1.product-report-be.list', vm.nav[i], null)
                vm.nav[i].children.map(item => {
                  switch(item.name) {
                    case 'hotpods':
                      this.checkChildMenuPermission(modules, 'post.v1.product-report.orders.outlets.hotpods', item)
                      break
                    case 'report_orders':
                      this.checkChildMenuPermission(modules, 'get.v1.product-report.orders.report-order', item)
                      break
                    case 'hit_rate_report':
                      this.checkChildMenuPermission(modules, 'get.v1.product-report.orders.hit-rate.', item)
                      break
                    case 'store_health_check':
                      this.checkChildMenuPermission(modules, 'get.v1.product-report.store.latest', item)
                      break
                    case 'hourly_sale_report':
                      this.checkChildMenuPermission(modules, 'get.v1.product-report.orders.hourly-sale.', item)
                      break
                    case 'roster_report':
                      this.checkChildMenuPermission(modules, 'get.v1.product-report.users.', item)
                      break
                    case 'sales_report':
                      this.checkChildMenuPermission(modules, 'get.v1.product-report.orders.new-sale-report', item)
                      break
                    case 'contactless_curbside_transactions':
                      this.checkChildMenuPermission(modules, 'get.v1.product-report.orders.contactless-curbside-transactions', item)
                      break
                    case 'coupon_redemption_report':
                      this.checkChildMenuPermission(modules, 'get.v1.product-report.coupon.coupon-redemption-reports', item)
                      break
                  }
                });
                break
              case 'blacklist_user':
                this.checkMenuPermission(modules, 'get.v1.product-order-be.blacklists', vm.nav[i], null)
                break
              case 'audit_trail':
                this.checkMenuPermission(modules, 'get.v1.product-report.audit-log.list', vm.nav[i], null)
                break
              case 'earning_framework':
                // this.checkMenuPermission(modules, 'get.v1.product-customer.earning-framework', vm.nav[i], null)
                break
              case 'reason_status':
                this.checkMenuPermission(modules, 'post.v1.product-tenant.reason-status', vm.nav[i], null)
                if (vm.nav[i].disable) {
                  this.checkMenuPermission(modules, 'put.v1.product-tenant.reason-status.?', vm.nav[i], null)
                }
                break
              case 'email_template':
                this.checkMenuPermission(modules, 'get.v3.product-notification-be.templates', vm.nav[i], null)
                break
              // case 'error_message':
              //   this.checkMenuPermission(modules, 'get.v1.product-tenant.error_messages', vm.nav[i], null)
              //   break
            }
          }
        }
      }
    }

    vm.nav.forEach(element => {
      if (element.name === 'main_report') {
        element.children.forEach(child => {
          if(!this.isPHMarket && ['roster_report', 'hit_rate_report'].includes(child.name)) {
            child.disable = true;
          }
        }) 
      }
      if (element.name === 'earning_framework') {
        if(!this.isJPMarket) {
          element.disable = true;
        }
      }
    });

    if (this.$store.getters.config.gms != null && this.$store.getters.config.gms.base != null && this.$store.getters.config.gms.base.logo != null) {
      this.logo = this.$store.getters.config.gms.base.logo
    }
  },
  computed: {
    isPHMarket() {
      return localStorage.getItem('clientID') === this.client_uuid.ph
    },
    isJPMarket() {
      return localStorage.getItem('clientID') === this.client_uuid.jp
    },
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    }
  },
  methods: {
    checkMenuPermission (modules, endPoint, navItem, arrModules = null) {
      let vm = this
      if (arrModules == null) {
        if (modules.indexOf(endPoint) === -1) {
          navItem.disable = true
          let sysModule = ['coupons', 'menus', 'combos', 'outlets', 'orders', 'category']
          let userModule = ['clients', 'users', 'roles']
          let name = navItem.alias || navItem.name
          if (sysModule.indexOf(name) > 0 && navItem.disable) {
            vm.sysFlag = true
          } else {
            vm.sysFlag = false
          }

          if (userModule.indexOf(name) > 0 && navItem.disable) {
            vm.userFlag = true
          } else {
            vm.userFlag = false
          }
        } else {
          navItem.disable = false
        }
      } else {
        for (let i in arrModules) {
          if (arrModules[i] === endPoint) {
            navItem.disable = false
            break
          } else {
            navItem.disable = true
          }
        }
      }
      
      // combine between permission and client config
      if (navItem.name === 'audit_trail' && navItem.disable === false) {
        navItem.disable = !((this.$store.getters.config.manual_config.enable_audit_trail || 0) == 1 ? true : false);
      }
    },
    checkChildMenuPermission (modules, endPoint, navItem) {
      if (modules.indexOf(endPoint) === -1) {
        navItem.disable = true;
      }
    },
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    asideToggle (e) {
      e.preventDefault()
      this.getMenuHistory()
      document.body.classList.toggle('aside-menu-hidden')
    },
    getTypeByStatus (status) {
      let type = 'default'
      switch (status.toString()) {
        case '1':
          type = 'dark'
          break
        case '2':
          type = 'warning'
          break
        case '3':
          type = 'primary'
          break
        case '4':
          type = 'success'
          break
      }

      return type
    },
    getMenuHistory () {
      this.menus = []
      for (let i = 0; i < 10; i++) {
        let status = 0
        if (i < 1) {
          status = Math.floor(Math.random() * 3) + 1
        } else {
          status = 4
        }
        this.menus.push({
          version: this.$moment().subtract(i, 'hours').unix(),
          user: 'Admin',
          time: this.$moment().subtract(i, 'hours').format('DD-MM-YYYY HH:mm:ss'),
          status: status
        })
      }
    },
    activeTheme(){
      this.changeTheme = this.$session.get('theme') !== undefined ? this.$session.get('theme') : true,
      this.isShowTheme = this.$session.get('show_config_christmas') !== undefined ? this.$session.get('show_config_christmas') : true,
      this.christmasTheme = this.$store.getters.config.main.christmas_theme !== undefined ? this.$store.getters.config.main.christmas_theme : false
    }
  },
  watch: {
    changeTheme(val){
      this.$session.set('theme',val)
      this.$session.set('show_config_christmas',false)
      this.changeTheme = val
      location.reload()
    },
    isShowTheme(val) {
      this.$session.set('show_config_christmas',val)
    },
    selected (val) {
      switch (val.toString()) {
        case '1':
          this.getMenuHistory()
          break
        case '2':
          break
        case '3':
          break
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/HomeLayout.vue